<template>
  <main class="view-send-otp-activation remove-body-top-padding d-flex flex-column text-dark">
    <article
      class="d-flex flex-xxs-column flex-md-row align-items-center justify-content-xxs-start justify-content-md-end vh-100"
    >
      <SubscriptionLoading v-if="isloading" :is-loading="true" />
      <section
        v-if="!IsRegisteredSuccessfully"
        class="bubble-information d-flex flex-column align-self-xxs-center align-self-sm-start mx-5"
        :class="{'no-animation': routeName=='vasSubscription'}"
      >
        <p
          class="text-white information-text m-0"
          :class="{'description-info': routeName == 'vasSubscription'}"
          v-html="$t(this.activationInfo, {products: this.globalResources.productTranslation.Plural})"
        />
      </section>
      <flexMobile
        class="activation-form d-xxs-none d-sm-flex flex-column"
        :mobile-content="MobileContent"
        :input-type="InputType"
        :is-registered-successfully="IsRegisteredSuccessfully"
        :server-error-message="serverErrorMessage"
        @CheckPin="CheckPin"
        @resendPin="resendPin"
      />
      <section class="flex-activation-form d-flex flex-column d-xxs-flex d-sm-none">
        <otpActivationForm
          :input-type="InputType"
          :is-registered-successfully="IsRegisteredSuccessfully"
          :server-error-message="serverErrorMessage"
          @CheckPin="CheckPin"
          @resendPin="resendPin"
        />
      </section>
    </article>

    <footer class="circles position-fixed d-flex">
      <div
        class="circle green d-xxs-none d-md-block"
        :class="{'no-animation': routeName == 'vasSubscription'}"
      />
      <div class="circle yellow" :class="{'no-animation': routeName == 'vasSubscription'}" />
      <div class="circle blue" :class="{'no-animation': routeName == 'vasSubscription'}" />
      <div
        class="circle red d-xxs-none d-md-block"
        :class="{'no-animation': routeName == 'vasSubscription'}"
      />
    </footer>
  </main>
</template>

<script>
import flexMobile from '@/components/FlexMobile.vue'
import pinInput from '@/components/PinInput.vue'
import SubscriptionLoading from '@/components/SubscriptionLoading.vue'
import { mapActions, mapGetters } from 'vuex'
import otpActivationForm from '@/components/OtpActivationForm.vue'
import utility from '@/utilities/utility'

export default {
  name: 'SendOtpActivation',
  components: {
    flexMobile,
    pinInput,
    SubscriptionLoading,
    otpActivationForm
  },
  computed: {
    ...mapGetters({
      routeName: 'order/routeName',
      subscriptionRequestResultReceived: 'subscription/subscriptionRequestResult',
      registerModel: 'registration/registerModel',
      designConfig: 'tenantDesign/config',
      isPinCodeSent: 'registration/isPinCodeSent'

    })
  },
  data () {
    return {
      serverErrorMessage: null,
      isloading: false,
      activationInfo: '',
      IsRegisteredSuccessfully: false,
      MobileContent: otpActivationForm,
      InputType: {
        changePhoneOrEmail: 'security.changePhoneNumber',
        activationType: 'security.cellActivation'
      },
      model: {
        pin: ''
      }
    }
  },
  methods: {
    ...mapActions({
      confirmPin: 'subscription/verify',
      // checkRequestStatus: "registration/checkRequestStatus",
      getUserStatus: 'registration/getUserStatus',
      sendPin: 'registration/resendPin',
      checkRequestStatus: 'subscription/checkRequestStatus',
      setTrialPeriod: "registration/setTrialPeriod"
    }),
    CheckPin (pin) {
      this.isloading = true

      var confirmInput = {
        requesterServiceRefCode: this.subscriptionRequestResultReceived.code,
        userInput: pin
      }
      this.confirmPin(confirmInput)
        .then(response => {
          var result = response.body.result

          if (result.status === 'Expired') {
            this.serverErrorMessage = this.$t('validations.messages._default', {
              fieldName: this.$t('security.pinInput')
            })
          } else if (result.status === 'MaxRetryReached') {
            this.serverErrorMessage = this.$t(
              'validations.messages.maxRetryReached'
            )
          } else if (result.status === 'Failed') {
            this.serverErrorMessage = this.$t('validations.messages._default', {
              fieldName: this.$t('security.pinInput')
            })
          } else if (result.status === 'Success') {
            return this.checkConfirmStatus()
          }

          this.isloading = false
        })
        .catch(err => {})
    },
    checkConfirmStatus () {
      var promise = this.checkRequestStatus(
        this.subscriptionRequestResultReceived.code
      ).then(response => {
        var result = response.body.result

        if (result === 'Failed') {
          this.isLoading = false
          this.serverErrorMessage = this.$t(
            'validations.messages.server_error'
          )
        } else if (result === 'FailedVerification') {
          this.isLoading = false
          this.serverErrorMessage = this.$t(
            'validations.messages.server_error'
          )
        } else if (result === 'Finalized') {
          this.isloading = false
          this.IsRegisteredSuccessfully = true
          this.setTrialPeriod(this.subscriptionRequestResultReceived.code);
          this.$router.push({ path: 'profile' })
        } else {
          setTimeout(() => {
            this.checkConfirmStatus()
          }, 2000)
        }
      })
      return promise
    },
    resendPin () {
      this.isLoading = true
      this.sendPin(this.registerModel).then(response => {
        this.isloading = false
        if (!this.isPinCodeSent) {
          this.serverErrorMessage = this.$t(
            'validations.messages.server_error'
          )
        }
      })
    },
    isInputTypeEmail () {
      let inputType = utility.getQueryStringValue('type')
      return inputType == 'email'
    },
    setViewText () {
      this.isInputTypeEmail()
        ? this.getEmailConfigurations()
        : this.getCellPhoneConfigurations()
    },
    getEmailConfigurations () {
      this.activationInfo = 'security.emailInfo'
      this.InputType = {
        changePhoneOrEmail: 'security.changeEmail',
        activationType: 'security.emailActivation'
      }
    },
    getCellPhoneConfigurations () {
      this.activationInfo = 'security.pinInfo'
      this.InputType = {
        changePhoneOrEmail: 'security.changePhoneNumber',
        activationType: 'security.cellActivation'
      }
    }
  },
  mounted () {
    this.setViewText()
  }
}
</script>
